export default __webpack_public_path__ + "static/media/listo_instrucciones.b01d4686.pdf";